function decreaseQuantity(event) {
    if (event && event.target) {
      var formElement = event.target.closest('.lsg-card-product__product-form');
      var quantityInput = formElement.querySelector('.lsg-card-product__quantity-selector input');
      var currentValue = parseInt(quantityInput.value);
      if (currentValue > 1) {
        quantityInput.value = currentValue - 1;
      }
    }
  }

  function increaseQuantity(event) {
    if (event && event.target) {
      var formElement = event.target.closest('.lsg-card-product__product-form');
      var quantityInput = formElement.querySelector('.lsg-card-product__quantity-selector input');
      var currentValue = parseInt(quantityInput.value);
      quantityInput.value = currentValue + 1;
    }
  }

  function descriptionHeight() {
    var descriptions = document.querySelectorAll('.lsg-card-product__description');
    var maxHeight = 0;
    if (descriptions.length) {
      descriptions.forEach(el => {
        var descriptionHeight = el.clientHeight; 
        if (descriptionHeight > maxHeight) {
            maxHeight = descriptionHeight;
        }
    });
      descriptions.forEach(el => {
        el.style.height = maxHeight + 'px';
    });
    }
}

  document.addEventListener('DOMContentLoaded', function() {
    var minusButtons = document.querySelectorAll('.lsg-card-product__minus-btn');
    var plusButtons = document.querySelectorAll('.lsg-card-product__plus-btn');

    minusButtons.forEach(function(button) {
      button.addEventListener('click', decreaseQuantity);
    });

    plusButtons.forEach(function(button) { 
      button.addEventListener('click', increaseQuantity);
    });

    descriptionHeight()
  });